import AutoAnimate from "../src/index.js";

document.addEventListener('alpine:init', () => {
    AutoAnimate(window.Alpine);
});
